import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'
const services = () => {
  return (
    <section id="services">
      <h5>What I Offer </h5>
      <h2>Services</h2>
      <div className="container services_container">
        <article className="service">
          <div className="service_head">
            <h3>UI/UX Designs</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
          </ul>
        </article>
        {/* Web-Dev  */}
        <article className="service">
          <div className="service_head">
            <h3>Web-Devlopment</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
          </ul>
        </article>
        {/* Graphic Designs */}
        <article className="service">
          <div className="service_head">
            <h3>Graphic Designing</h3>
          </div>
          <ul className="service_list">
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
            <li>
              <BiCheck className="service_icon" />
              <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus neque deleniti labore animi dolor?
              </p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  )
}

export default services